export default (that) => [
  {
    text: that.$l('btn_view_details') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_edit_product') || '编辑产品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ evgCombineStatus }) => {
      return !!(
        !['Q'].includes(evgCombineStatus)

      )
    },
  },
  {
    text: that.$l('btn_delete_product') || '删除产品',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ evgCombineStatus }) => {
      return !!(
        !['Q'].includes(evgCombineStatus)
      )
    },
  },
  {
    text: that.$l('btn_fullMember_product') ||'转正产品',
    icon: 'el-icon-circle-check',
    menuType: 'fullMember',
    allow: 'F',
    divided: true,
    disabled: ({ evgCombineStatus }) => !['Q'].includes(evgCombineStatus),
  },
]
